import { Component, OnInit } from '@angular/core';
import { SeleccionService } from '../../servicios/seleccion.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { configuracion } from '../../recursos/config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ficha-estudiante',
  templateUrl: './ficha-estudiante.component.html',
  styleUrls: ['./ficha-estudiante.component.css']
})
export class FichaEstudianteComponent implements OnInit {

  public vecPais = []; public vecProvincia = []; public vecCiudad = []; public vecParroquia = [];
  public vecCiudad1 = []; public vecCiudad2 = []; public vecParroquia1 = [];

  public nombreBeca: string = ""; public detBeca: string = ""; public indBeca: string = "";
  public vecDatosEst = []; public vecGrupos = []; public vecPregunta = []; public vecOpcion = []; public vecOtros = [];
  public vecRespGrupos = []; public vecRespPregunta = []; public vecRespOpcion = []; public vecRespOtros = []; public vecRespAnterior = [];
  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private alerti: AlertifyService, private srvInsert: IngresoService,
    private confMensaje: configuracion, private ruta: Router) { }
  async ngOnInit() {
    await this.verProvincias();
    if (localStorage.getItem('localEstudiante') == 'na' || localStorage.getItem('localPeriodo') == 'na' || localStorage.getItem('localNombre') == '') {
      this.ruta.navigate(["/becario"]);
      localStorage.setItem('localResponde', '-1');
    }
    else {
      await this.verProvincias();
      await this.verDatosEstudiante();
      await this.verDatosEncuesta();
    }
  }
  //CARGA LOS DATOS DEL ESTUDIANTE QUE SE TIENE DISPONIBLE
  async verDatosEstudiante() {
    this.vecDatosEst = []; this.vecRespAnterior = [];

    const resHCE = await new Promise<any>(resolve =>
      this.srvSelect.medicoverHCE(4, localStorage.getItem('ciUsuario'), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resHCE.success)
      this.vecDatosEst.push({
        dato1: localStorage.getItem('localNombre') + ' ' + localStorage.getItem('localApellidos'), dato2: localStorage.getItem('localApellidos'),
        dato3: localStorage.getItem('ciUsuario'), dato4: localStorage.getItem('localEstudiante'),
        dato5: '', dato6: '', dato7: '', dato8: '', dato9: '', dato10: localStorage.getItem('localFechaN'),
        dato11: localStorage.getItem('localSexo') == '1' ? 'HOMBRE' : 'MUJER', dato12: localStorage.getItem('localCorreo'),
        dato13: localStorage.getItem('localCorreoPer'), dato14: localStorage.getItem('localCivil'), dato15: localStorage.getItem('localNombFacultad'),
        dato16: localStorage.getItem('localNombCarrera'), dato17: localStorage.getItem('localCodNivel'),
        dato18: localStorage.getItem('localSede'), dato19: localStorage.getItem('localNomColegio'),
        dato20: localStorage.getItem('localTitColegio'), dato21: localStorage.getItem('localAniColegio'),
        dato22: localStorage.getItem('localTipColegio'),
        dato26: resHCE.citas[0]['EMERGENCIA'],
        dato27: resHCE.citas[0]['RELACION'],
        dato28: resHCE.citas[0]['TELEFONO_E'],
        dato29: localStorage.getItem('localEtnia'),
        dato30: resHCE.citas[0]['genero'],
        dato31: resHCE.citas[0]['discapacidad'],
        dato32: resHCE.citas[0]['porcentaje'],
        dato33: resHCE.citas[0]['grupo'],
        dato34: localStorage.getItem('localMatMaricula'),
        dato35: localStorage.getItem('localProcede')
      });
    //OBTENEMOS LAS RESPUESTAS ANTERIORES A LA FICHA ACTUAL
    const respAnt = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(76, localStorage.getItem('ciUsuario'), localStorage.getItem('localResponde'), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (respAnt.success) {
      this.vecRespAnterior = respAnt.encuesta;
    }
    this.verGruposPreguntas();
  }

  //MOSTRAR LA INFORMACION DE LA ENCUESTA SELECCIONADA
  async verDatosEncuesta() {
    const resEnc = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(12, localStorage.getItem('localNumEnc'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEnc.success) {
      this.nombreBeca = resEnc.encuesta[0]['strNombre']
      this.detBeca = resEnc.encuesta[0]['strDescripcion']
      this.indBeca = resEnc.encuesta[0]['strRecomendacion']
    }
    else
      this.alerti.message('No se encntró información de la encuesta Seleccionada');
  }
  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verGruposPreguntas() {
    this.vecGrupos = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(61, localStorage.getItem('localNumEnc'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecGrupos = resGrupo.encuesta;
      await this.verAsignaciones();
    }
    else
      this.alerti.error('La ecnuesta selecciona no dispone de grupos de preguntas en ese momento');
  }
  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verAsignaciones() {
    this.cargando.abrir();
    this.vecPregunta = []; this.vecOpcion = []; this.vecOtros = []; var contPreg = 0;
    this.vecRespGrupos = []; this.vecRespPregunta = []; this.vecRespOpcion = []; this.vecRespOtros = [];
    const resGrupo = await new Promise<any>(resolve =>
      //VER LAS PREGUNTAS ASIGNADAS A UNA ENCUESTA DADO SU ID (62)
      this.srvSelect.gestionEncuesta(62, localStorage.getItem('localNumEnc'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      for (let objPreg of resGrupo.encuesta) {
        contPreg++;
        this.vecPregunta.push({
          numero: objPreg.intOrden, buscPreg: objPreg.buscPreg, descGrup: objPreg.descGrup, descPreg: objPreg.descPreg,
          estGrupo: objPreg.estGrupo, estGrupoEncu: objPreg.estGrupoEncu, estGrupoPreg: objPreg.estGrupoPreg,
          estPreg: objPreg.estPreg, idEncuesta: objPreg.idEncuesta, intIdGrupPreg: objPreg.intIdGrupPreg,
          intIdGrupo: objPreg.intIdGrupo, intIdPregunta: objPreg.intIdPregunta, nombGrupo: objPreg.nombGrupo,
          nombPreg: objPreg.nombPreg, numPregunta: objPreg.numPregunta, clase: 'lblSiRespuesta'
        });
      }
      //VER LAS OPCIONES DADAS A LAS PREGUNTAS ASIGNADAS DE UNA ENCUESTA DADO SU ID (63)
      const resOpcion = await new Promise<any>(resolve =>
        this.srvSelect.gestionEncuesta(63, localStorage.getItem('localNumEnc'), 'na', 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resOpcion.success)
        this.vecOpcion = resOpcion.encuesta;
      //VER LAS OTRAS OPCIONES DE LAS OPCIONES DADAS A LAS PREGUNTAS ASIGNADAS DE UNA ENCUESTA DADO SU ID (64)
      const resOtros = await new Promise<any>(resolve =>
        this.srvSelect.gestionEncuesta(64, localStorage.getItem('localNumEnc'), 'na', 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resOtros.success)
        this.vecOtros = resOtros.encuesta;

      for (let objPreg of this.vecPregunta) {
        //REGISTRAR LAS PREGUNTAS DE UNA ENCUESTA
        await this.registroPreguntas((localStorage.getItem('localEstudiante') + '_' + localStorage.getItem('localResponde') + '_' + objPreg.intIdGrupPreg),
          objPreg.intIdGrupo, objPreg.intIdGrupPreg, objPreg.nombGrupo, objPreg.descGrup, objPreg.intIdPregunta, objPreg.nombPreg, objPreg.descPreg, objPreg.numero,
          objPreg.buscPreg, localStorage.getItem('localPeriodo'), localStorage.getItem('localResponde'), 5);
      }

      const resRespGrupo = await new Promise<any>(resolve =>
        this.srvSelect.gestionEncuesta(71, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resRespGrupo.success) {
        this.vecRespGrupos = resRespGrupo.encuesta;

        const resRespPreg = await new Promise<any>(resolve =>
          this.srvSelect.gestionEncuesta(72, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resRespPreg.success) {
          this.vecRespPregunta = resRespPreg.encuesta;
          for (let objResPreg of this.vecRespPregunta) {

            for (let objOpcion of this.vecOpcion) {
              if (objResPreg.intIdGrupoPreg == objOpcion.intIdGrupPreg) {
                let auxOpcion = this.vecRespAnterior.find(index => index.intIdPregunta == objOpcion.intIdPregunta && index.intIdOpcion == objOpcion.intIdOpcion);
                await this.registroPreguntas((objResPreg.strIdPregunta + '_' + objOpcion.intIdOpcion),
                  objOpcion.intIdPregunta, objOpcion.intIdOpcion, objOpcion.nombOpcion, objOpcion.descOpcion, objOpcion.fltPeso, objOpcion.tipoOpcion, objOpcion.tipoOpcion,
                  objResPreg.intBuscaPreg == 0 ? auxOpcion == null ? '' : auxOpcion.strRespuesta : this.vecDatosEst[0]['dato' + objResPreg.intBuscaPreg],
                  localStorage.getItem('localPeriodo'), localStorage.getItem('localResponde'), objResPreg.strIdPregunta, 6);
              }
            }
          }
          const resRespOpcion = await new Promise<any>(resolve =>
            this.srvSelect.gestionEncuesta(73, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (resRespOpcion.success) {
            this.vecRespOpcion = resRespOpcion.encuesta;
            for (let objResOp of this.vecRespOpcion) {
              for (let objOtro of this.vecOtros) {
                if (objResOp.intIdOpcion == objOtro.opcionOtro)
                  await this.registroPreguntas((objResOp.strIdOpcion + '_' + objOtro.intIdOtroO), objOtro.intIdPregunta, objOtro.intIdOpcion, objOtro.intIdOtroO, objOtro.enunciadoOtro,
                    objOtro.nombOtro, objOtro.descOtro, objOtro.fltPeso, objOtro.tipoOtro, '', localStorage.getItem('localResponde'), objResOp.strIdOpcion, 7);
              }
            }
          }
        }
      }

      const resRespOtro = await new Promise<any>(resolve =>
        this.srvSelect.gestionEncuesta(74, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resRespOtro.success)
        this.vecRespOtros = resRespOtro.encuesta;
      this.cargando.cerrar();
    }
  }
  registroPreguntas(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, opc) {
    this.srvInsert.ingresoFicha(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, 'na', 'na', 'na',
      'na', 'na', 'na', opc).subscribe(res => {
        if (!res.ecnuesta) {
          this.alerti.message('Procesando datos');
        }
      });
  }
  registroRespuestas(objResp, op) {
    if (objResp.intTipo == 1 || objResp.intTipo == 2) {
      this.srvInsert.ingresoFicha(objResp.intIdPregunta, objResp.responde, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na',
        'na', 'na', 'na', 'na', 9).subscribe(res => {
          this.registroPreguntas(objResp.strIdOpcion, (objResp.intTipo == 1 || objResp.intTipo == 2) ? 'true' : objResp.strRespuesta, 'na', 'na', 'na',
            'na', 'na', 'na', 'na', 'na', 'na', 'na', op);
        });
    }
    else
      this.registroPreguntas(objResp.strIdOpcion, (objResp.intTipo == 1 || objResp.intTipo == 2) ? 'true' : objResp.strRespuesta, 'na', 'na', 'na', 'na',
        'na', 'na', 'na', 'na', 'na', 'na', op);
  }
  verMarca(objOpcion) {
    for (let objOp of this.vecRespOpcion) {
      if (objOp.strPregunta == objOpcion.strPregunta)
        objOp.strRespuesta = 'false';
    }
    objOpcion.strRespuesta = 'true';
  }
  registroOpcionOtros(objOtro, op) {
    if (objOtro.intTipo == 1 || objOtro.intTipo == 2) {
      this.srvInsert.ingresoFicha(objOtro.intIdOpcion, objOtro.responde, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na',
        'na', 'na', 'na', 'na', 11).subscribe(res => {
          this.registroPreguntas(objOtro.strIdOtro, (objOtro.intTipo == 1 || objOtro.intTipo == 2) ? 'true' : objOtro.strRespuesta, 'na', 'na', 'na',
            'na', 'na', 'na', 'na', 'na', 'na', 'na', op);
        });
    }
    else
      this.registroPreguntas(objOtro.strIdOtro, (objOtro.intTipo == 1 || objOtro.intTipo == 2) ? 'true' : objOtro.strRespuesta, 'na', 'na', 'na',
        'na', 'na', 'na', 'na', 'na', 'na', 'na', op);
  }
  //VER LAS CIUDADES QUE PERTENECEN A UNA PROVINCIA SELECCIONADA EN LA BASE DE DATOS DEL MÉDICO
  async verPais(objPais) {
    this.registroPreguntas(objPais.strIdOpcion, objPais.strRespuesta, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 8);
  }
  //VER LAS PROVINCIAS CARGADAS EN LA BASE DE DATOS DEL MÉDICO
  async verProvincias() {
    this.vecPais = []; this.vecProvincia = []; this.vecCiudad = []; this.vecParroquia = []; this.vecParroquia1 = [];
    this.vecCiudad1 = []; this.vecCiudad2 = [];

    const resProv = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(2, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resProv.success)
      this.vecProvincia = resProv.ciudad;

    const resPais = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(5, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPais.success)
      this.vecPais = resPais.ciudad;

    const resProc = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(1, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resProc.success) {
      this.vecParroquia = resProc.ciudad;
      this.vecParroquia1 = resProc.ciudad;
    }
    const resCiudad = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(11, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCiudad.success) {
      this.vecCiudad = resCiudad.ciudad;
      this.vecCiudad1 = resCiudad.ciudad;
      this.vecCiudad2 = resCiudad.ciudad;
    }
  }
  //VER LAS CIUDADES QUE PERTENECEN A UNA PROVINCIA SELECCIONADA EN LA BASE DE DATOS DEL MÉDICO
  async verCiudad(objProv) {
    this.registroPreguntas(objProv.strIdOpcion, objProv.strRespuesta, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 8);
    const resCiudad = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(3, objProv.strRespuesta, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCiudad.success) {
      if (objProv.intIdOpcion == 7)
        this.vecCiudad = resCiudad.ciudad;
      if (objProv.intIdOpcion == 28)
        this.vecCiudad1 = resCiudad.ciudad;
      if (objProv.intIdOpcion == 226)
        this.vecCiudad2 = resCiudad.ciudad;
    }
  }
  //VER LAS PARROQUIAS QUE PERTENECEN A UNA CIUDAD SELECCIONADA EN LA BASE DE DATOS DEL MÉDICO
  async verParroquia(objCiudad, op) {
    this.registroPreguntas(objCiudad.strIdOpcion, objCiudad.strRespuesta, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 8);

    const resCiudad = await new Promise<any>(resolve =>
      this.srvSelect.medicoverProvincia(4, objCiudad.strRespuesta, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCiudad.success) {
      if (op == 1)
        this.vecParroquia = resCiudad.ciudad;
      if (op == 2)
        this.vecParroquia1 = resCiudad.ciudad;
    }
  }
  verDatoParroquia(objProc) {
    this.registroPreguntas(objProc.strIdOpcion, objProc.strRespuesta, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 8);
  }
  async envioFicha() {
    if (this.vecRespPregunta.length > 5) {
      this.cargando.abrir();
      var banEnvio = 0;
      for (let objPreg of this.vecRespPregunta) {
        objPreg.clase = 'lblSiRespuesta';
        var ban = 0; var contOp = 0;
        while (ban == 0 && contOp < this.vecRespOpcion.length) {
          if (objPreg.strIdPregunta == this.vecRespOpcion[contOp]['strPregunta']) {
            if (this.vecRespOpcion[contOp]['strRespuesta'] == '' || this.vecRespOpcion[contOp]['strRespuesta'] == 'null') {
              objPreg.clase = 'lblNoRespuesta';
              ban = 1; banEnvio++;
            }
          }
          contOp++;
        }
      }
      if (banEnvio > 0) {
        this.alerti.error('Debe completar todas las preguntas');
        this.cargando.cerrar();
      }
      else {
        this.srvInsert.ingresoEncuesta(localStorage.getItem('localResponde'), 1, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 10).subscribe(resEnvio => {
          if (resEnvio.encuesta)
            this.enviarCorreo();
        });
      }
    }
    else {
      this.alerti.error('El cuestionario no disponde de preguntas intente nuevamente');
      this.ruta.navigate(["/becario"]);
    }
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo() {
    let contenido = this.confMensaje.bodyMensaje(1,'na','na', 'na', 'na', 'na') + localStorage.getItem('localNombre') + ' ' + localStorage.getItem('localApellidos') +
      this.confMensaje.bodyMensaje(10,'na','na', 'na', 'na', 'na');
    this.srvInsert.envioMail('Ficha del estudiante: ' + this.nombreBeca, localStorage.getItem('localCorreo'), btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.correo)
        this.alerti.error("Error al enviar el correo electrónico");
      else {
        this.alerti.success('Ficha registrada con éxito');
        /*this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'Asignación y notificación de becas',
          'Asigna la beca de ' + this.nombreBeca + ' al estudiante: ' + this.vecNotifica[0]['nombre'], 14, 'Cod Carrera: ' + this.notCodCarrera + '; Cod Periodo: ' + this.notCodPeriodo
          + '; Cod Semestre: ' + this.notCodNivel, 1).subscribe(res => {
          });*/
        localStorage.setItem('localResponde', '-1');
        localStorage.setItem('localNumEnc', '-1');
        localStorage.setItem('localNumInt', '-1');
        this.ruta.navigate(["/becario"]);
      }
    });
    this.cargando.cerrar();
  }
}

